<dspx-card-set-base-form [formServiceEndpoint]="formServiceEndpoint"
                         [templateId]="templateId"
                         [versionNo]="versionNo"
                         [model]="model"
                         formName="Care Allowance Placement List"
                         (onFormLoad)="formLoad($event)"
                         (onDialogSubmit)="handleDialogButtonClick($event, activeDialog)"
                         (onActionButtonClick)="handleActionButtonClick($event)"
                         (onFilter)="filterData($event)">
</dspx-card-set-base-form>
